import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";

const getClientId = () => {
  let id = localStorage.getItem("wardogs_client_id");
  if (!id) {
    id = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`);
    localStorage.setItem("wardogs_client_id", id);
  }
  return id;
};

// Invisible site-wide heartbeat so /presence can report real online users + visitors.
const PresenceTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const cid = getClientId();
    const ping = () => api.post("/presence/ping", { client_id: cid, path: window.location.pathname }).catch(() => {});
    ping();
    const t = setInterval(ping, 25000);
    const onVis = () => { if (document.visibilityState === "visible") ping(); };
    document.addEventListener("visibilitychange", onVis);
    return () => { clearInterval(t); document.removeEventListener("visibilitychange", onVis); };
  }, []);

  // Re-ping instantly whenever the route changes so the admin live view is near-instant.
  useEffect(() => {
    const cid = getClientId();
    api.post("/presence/ping", { client_id: cid, path: location.pathname }).catch(() => {});
  }, [location.pathname]);

  return null;
};

export default PresenceTracker;
